import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function TransformationSection() {
  return <section className="py-24 px-4 bg-warm-gradient" data-id="element-221">
      <div className="max-w-4xl mx-auto text-center" data-id="element-222">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white p-10 md:p-16 rounded-[2rem] shadow-xl border border-white/50 relative" data-id="element-223">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-terracotta text-white p-3 rounded-full shadow-lg" data-id="element-224">
            <Sparkles className="w-6 h-6" data-id="element-225" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brown mb-8" data-id="element-226">
            Imagina cómo se sentiría...
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-brown-light leading-relaxed" data-id="element-227">
            <p data-id="element-228">
              Tener por fin esa paz. Llegar a la cama no para discutir en
              susurros agresivos, sino para descansar de verdad.
            </p>
            <p data-id="element-229">
              Imagina mirar a tu pareja y saber que, aunque no estén de acuerdo
              en todo de inmediato,{' '}
              <span className="font-bold text-terracotta" data-id="element-230">
                tienen un sistema
              </span>{' '}
              que pone fin a las discusiones recurrentes.
            </p>
            <p data-id="element-231">
              Imagina que la crianza vuelve a ser un equipo, no una competencia
              de quién está más cansado.
            </p>
          </div>

          <div className="mt-10 pt-10 border-t border-gray-100" data-id="element-232">
            <p className="font-serif italic text-2xl text-terracotta" data-id="element-233">
              "Tu pareja y tú merecen esta paz."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}